export default __webpack_public_path__ + "static/media/15.d12d7eea.png";